import React from 'react';

// Vape-themed SVG avatars. Each returned as data-URL friendly string for use as picture.
// Rendered as React components; each takes a size prop.

const AVATARS = [
  {
    id: 'vape-orange',
    name: 'Vape Naranja',
    bg: 'linear-gradient(135deg,#f97316,#dc2626)',
    svg: (
      <svg viewBox="0 0 64 64" fill="none">
        <rect x="20" y="10" width="24" height="44" rx="6" fill="#fff" />
        <rect x="24" y="14" width="16" height="20" rx="2" fill="#111" opacity="0.8" />
        <circle cx="32" cy="46" r="4" fill="#f97316" />
        <path d="M28 6 Q32 2 36 6" stroke="#fff" strokeWidth="2" fill="none" opacity="0.6" />
      </svg>
    ),
  },
  {
    id: 'vape-cyan',
    name: 'Pod Cian',
    bg: 'linear-gradient(135deg,#06b6d4,#3b82f6)',
    svg: (
      <svg viewBox="0 0 64 64" fill="none">
        <rect x="22" y="8" width="20" height="48" rx="10" fill="#fff" />
        <ellipse cx="32" cy="18" rx="6" ry="3" fill="#06b6d4" />
        <rect x="26" y="30" width="12" height="18" rx="2" fill="#1e293b" opacity="0.8" />
      </svg>
    ),
  },
  {
    id: 'cloud-pink',
    name: 'Nube Rosa',
    bg: 'linear-gradient(135deg,#ec4899,#a855f7)',
    svg: (
      <svg viewBox="0 0 64 64" fill="none">
        <circle cx="24" cy="34" r="10" fill="#fff" opacity="0.9" />
        <circle cx="36" cy="30" r="12" fill="#fff" opacity="0.95" />
        <circle cx="44" cy="38" r="8" fill="#fff" opacity="0.85" />
        <circle cx="20" cy="22" r="4" fill="#fff" opacity="0.7" />
        <circle cx="46" cy="20" r="3" fill="#fff" opacity="0.6" />
      </svg>
    ),
  },
  {
    id: 'juice-purple',
    name: 'E-Juice Púrpura',
    bg: 'linear-gradient(135deg,#8b5cf6,#4f46e5)',
    svg: (
      <svg viewBox="0 0 64 64" fill="none">
        <rect x="24" y="10" width="16" height="6" fill="#fff" />
        <rect x="20" y="16" width="24" height="40" rx="3" fill="#fff" />
        <rect x="24" y="22" width="16" height="28" rx="2" fill="#8b5cf6" opacity="0.85" />
        <circle cx="32" cy="36" r="3" fill="#fff" />
      </svg>
    ),
  },
  {
    id: 'lightning-yellow',
    name: 'Rayo Amarillo',
    bg: 'linear-gradient(135deg,#facc15,#f97316)',
    svg: (
      <svg viewBox="0 0 64 64" fill="none">
        <path d="M36 6 L18 34 L28 34 L24 58 L46 26 L34 26 Z" fill="#fff" />
      </svg>
    ),
  },
  {
    id: 'mod-green',
    name: 'Mod Verde',
    bg: 'linear-gradient(135deg,#10b981,#0d9488)',
    svg: (
      <svg viewBox="0 0 64 64" fill="none">
        <rect x="16" y="20" width="32" height="30" rx="4" fill="#fff" />
        <rect x="20" y="24" width="24" height="14" rx="1" fill="#111" />
        <text x="32" y="35" textAnchor="middle" fill="#10b981" fontSize="8" fontWeight="bold">MOD</text>
        <rect x="22" y="12" width="20" height="10" rx="2" fill="#fff" />
      </svg>
    ),
  },
  {
    id: 'skull-red',
    name: 'Skull Rojo',
    bg: 'linear-gradient(135deg,#dc2626,#000)',
    svg: (
      <svg viewBox="0 0 64 64" fill="none">
        <path d="M32 10 C20 10 14 20 14 30 L14 42 L20 42 L20 48 L26 48 L26 52 L38 52 L38 48 L44 48 L44 42 L50 42 L50 30 C50 20 44 10 32 10 Z" fill="#fff" />
        <circle cx="24" cy="30" r="4" fill="#000" />
        <circle cx="40" cy="30" r="4" fill="#000" />
        <path d="M28 40 L32 44 L36 40" stroke="#000" strokeWidth="2" fill="none" />
      </svg>
    ),
  },
  {
    id: 'star-blue',
    name: 'Estrella Azul',
    bg: 'linear-gradient(135deg,#0ea5e9,#1e40af)',
    svg: (
      <svg viewBox="0 0 64 64" fill="none">
        <path d="M32 6 L38 24 L58 24 L42 36 L48 54 L32 44 L16 54 L22 36 L6 24 L26 24 Z" fill="#fff" />
      </svg>
    ),
  },
];

export const VapeAvatar = ({ id, size = 64, className = '' }) => {
  const av = AVATARS.find((a) => a.id === id) || AVATARS[0];
  return (
    <div
      className={`inline-flex items-center justify-center rounded-full overflow-hidden ${className}`}
      style={{ background: av.bg, width: size, height: size }}
    >
      <div style={{ width: size * 0.75, height: size * 0.75 }}>{av.svg}</div>
    </div>
  );
};

export const VAPE_AVATAR_IDS = AVATARS.map((a) => a.id);

// Return an identifier string used to store in DB as picture value
export const avatarValue = (id) => `avatar:${id}`;

// Parse a picture value and render appropriately
export const UserAvatar = ({ picture, name, phone, email, size = 40, className = '' }) => {
  const initial = (name || phone || email || 'U').slice(0, 1).toUpperCase();
  if (picture && picture.startsWith('avatar:')) {
    return <VapeAvatar id={picture.replace('avatar:', '')} size={size} className={className} />;
  }
  if (picture && (picture.startsWith('http') || picture.startsWith('data:'))) {
    return (
      <img
        src={picture}
        alt={name || 'avatar'}
        className={`rounded-full object-cover ${className}`}
        style={{ width: size, height: size }}
      />
    );
  }
  return (
    <div
      className={`rounded-full bg-orange-500 text-black flex items-center justify-center font-bold ${className}`}
      style={{ width: size, height: size, fontSize: size * 0.4 }}
    >
      {initial}
    </div>
  );
};

export default AVATARS;
